import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-CropShape",
  "use": "svg-icon-CropShape-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg-icon-CropShape\"><path d=\"M8.25 2.25h1.5V7.5h-1.5V3.75H0v-1.5h8.25zm-4.5 7.5h-1.5V4.5h1.5v3.75H12v1.5H3.75zM2.25 0h1.5v1.5h-1.5V0zm6 10.5h1.5V12h-1.5v-1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol